import { Component } from "react";
import { Bot } from "lucide-react";

export class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#05050A] text-white flex flex-col items-center justify-center px-6 text-center" data-testid="error-boundary-fallback">
          <span className="w-14 h-14 rounded-2xl bg-gradient-to-br from-[#B026FF] to-[#00F5FF] flex items-center justify-center mb-6">
            <Bot size={28} />
          </span>
          <h1 className="font-heading text-xl font-black mb-2">Something went wrong / Algo salió mal</h1>
          <p className="text-sm text-[#A0A0B0] mb-8 max-w-sm">Your avatar hit an unexpected glitch. / Tu avatar encontró un fallo inesperado.</p>
          <button onClick={() => window.location.reload()} data-testid="error-reload-btn"
            className="px-8 py-3.5 rounded-full text-xs font-bold uppercase tracking-widest bg-[#B026FF] shadow-[0_0_20px_rgba(176,38,255,0.45)]">
            Reload / Recargar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
